import { Carousel } from '@/components/Carousel/Carousel.js';
import { RecommendationCard } from '@/components/Recommendation/RecommendationCard/RecommendationCard.js';
import {
  AvatarsAndNames,
  RecommendationCardReadMore,
  RecommendationCardReview,
} from '@/components/Recommendation/RecommendationCard/RecommendationCard.styles.js';
import { styled } from '@/stitches/index.js';
import { pxToRem } from '@/utilities/pxToRem.js';

export const StyledRecommendationCard = styled(RecommendationCard, {
  $$cardMaxWidth: '100%',
  $$namesFontSize: '$sizes$14',
  $$namesFontWeight: 400,
  $$namesLetterSpacing: '$letterSpacings$1_5',
  $$namesLineHeight: pxToRem(19.6),
  '@bp0': {
    $$reviewFontSize: '$sizes$18',
  },
  '@bp2': {
    $$reviewFontSize: '$sizes$28',
  },
  fontWeight: 400,
  [`${AvatarsAndNames}`]: {
    justifyContent: 'center',
  },
  [`${RecommendationCardReview}`]: {
    fontFamily: '$heading',
    fontSize: '$$reviewFontSize',
    textAlign: 'center !important',
  },
  [`${RecommendationCardReadMore}`]: {
    '@bp0': {
      alignSelf: 'flex-start',
    },
    '@bp3': {
      alignSelf: 'center',
    },
  },
  textAlign: 'center',
  width: '100%',
  [`${AvatarsAndNames}`]: {
    '& p': {
      fontSize: '$18',
      fontWeight: 500,
      letterSpacing: pxToRem(1),
      lineHeight: 1.4,
      textTransform: 'uppercase',
    },
  },
});

const slickTrack = '.slick-slider > .slick-list .slick-track';
export const Container = styled('div', {
  '@bp0': {
    '.slick-slide.slick-active > div > div': {
      width: '100%',
    },
    '.slick-slider > svg.slick-arrow': {
      color: '$defaultFont',
      height: 'unset',
      width: 'unset',
      zIndex: '$navDrawer',
    },
  },
  '@bp2': {
    '.slick-slide > div': {
      padding: '0 $100',
    },
  },

  variants: {
    justifyTrack: {
      center: {
        [`${slickTrack}`]: {
          justifyContent: 'center',
          margin: '0 auto',
        },
      },
      start: {
        [`${slickTrack}`]: {
          justifyContent: 'flex-start',
        },
      },
    },
  },
});

export const StyledCarousel = styled(Carousel, {
  '.slick-prev, .slick-next': {
    marginTop: '$88',
    top: '0',
  },
});

export const ControlsContainer = styled('div', {
  '@bp0': {
    display: 'flex',
  },
  '@bp2': {
    display: 'none',
  },
  alignItems: 'center',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  marginTop: '$40',
  variants: {
    hide: {
      true: {
        display: 'none',
      },
    },
  },
});

export const Controls = styled('div', {
  alignSelf: 'flex-start',
  display: 'flex',
  flexFlow: 'row nowrap',
  gap: '$32',
});

export const Arrow = styled('a', {
  color: '$defaultFont',
  textAlign: 'center',
});
